const driverLicenseFileTypes = {
    FRONT_WITH_HOLOGRAM: 'FRONT_WITH_HOLOGRAM',
    BACK_WITH_HOLOGRAM: 'BACK_WITH_HOLOGRAM',
    BACK_WITH_HOLOGRAM_LETTERS: 'BACK_WITH_HOLOGRAM_LETTERS',
    BACK_WITH_HOLOGRAM_SIGNS: 'BACK_WITH_HOLOGRAM_SIGNS',
};

export default driverLicenseFileTypes;
